@if (view.site && view.site.profile && view.site.profile.pages) {
    @switch (view.site.profile.pages.team) {
        @case (1) {
            <app-team-type01 class="w-full"></app-team-type01>
            }
        @case (2) {
            <app-team-type02 class="w-full"></app-team-type02>
            }
        @case (3) {
            <app-team-type03 class="w-full"></app-team-type03>
            }
    }
}